export const SESSION_TIMEOUT = 2 * 3600000;
export const REFRESH_INTERVAL = 240 * 1000;

export const STATUS_OPTIONS = [
  { text: 'ALL STATUS', value: 'all' },
  { text: 'CREATED', value: 'created' },
  { text: 'DRAFT', value: 'draft' },
  { text: 'IN PROGRESS', value: 'in_progress' },
  { text: 'COMPLETED', value: 'completed' },
];

export const STORAGE_KEYS = {
  TOKEN_REFRESH: 'tokenRefreshTime',
  CUSTOM_TOKEN: 'token',
  KEY_KEY: 'key',
  IV_KEY: 'iv',
};

export const CATEGORY = {
  SOLAR: 'solar',
  CONSTRUCTION: 'construction',
};

export const SOLAR_TYPE = {
  SCPM: 'SCPM',
  SCQM: 'SCQM',
};

export const CHART_TYPES = {
  LINE: 'line',
  STACKED: 'stacked',
};

export const VIEWS = {
  GLOBAL: 'global',
  INVERTER: 'inverter',
};

export const CHART_COLORS = {
  ACTUAL: '#1f77b4',
  TARGET: '#ff7f0e',
};
